import classNames from "classnames";
import PropTypes from "prop-types";
import { Button as MuiButton } from "@mui/material";
import styles from "./button.styles.module.scss";

const propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.any, // ReactNode | ReactNode[] | string
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  rootClassName: PropTypes.string,
  /** @deprecated no longer used, can be removed from any component passing prop */
  isTextCapitalizationOff: PropTypes.bool,
};
/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const Button = ({
  ariaLabel = "",
  children,
  disabled = false,
  href = "",
  onClick = (..._args) => { },
  rootClassName = "btn-tertiary",
}) => {
  return (
    <MuiButton
      aria-label={ariaLabel || null}
      className={classNames("gx-button", rootClassName, styles.root)}
      color="primary"
      disabled={disabled}
      disableElevation={true}
      href={href || null}
      onClick={onClick}
      variant="text"
    >
      {children}
    </MuiButton>
  );
};

Button.propTypes = propTypes;
export { Button };
